// extracted by mini-css-extract-plugin
export var chart = "styles-module--chart--DN8ll";
export var chartPlaceholder = "styles-module--chartPlaceholder--yMItR";